export default __webpack_public_path__ + "static/media/image-camp.ff43646c.jpg";